function string2color(str) {
  let hash = function(word) {
    let h = 0;
    for (let i = 0; i < word.length; i++) {
      h = word.charCodeAt(i) + ((h << 5) - h);
    }
    return h;
  };

  let int_to_rgba = function(i) {
    let color =
      ((i >> 24) & 0xff) +
      "," +
      ((i >> 16) & 0xff) +
      "," +
      ((i >> 8) & 0xff) +
      "," +
      "0.2";
    return "rgba(" + color + ")";
  };

  return int_to_rgba(hash(str));
}

export default string2color;
